@if (showEventTimerInfoSection) {
    @if (event.favourited && !hideFavouriteIcon) {
        <vn-icon class="favourite selected" name="theme-favorite-i" size="10" />
    }
    @if (event.scoreboard.started) {
        <i class="live-icon" [class.live-red-dot]="isLeagueChildPageDesign && !isOutrightMarket">{{ liveIconText }}</i>
    }
    @if (raceInfo) {
        <ms-race-info [event]="event" />
    }
    @if (event.liveAlert) {
        <ms-alert class="alert-icon alert-grid-view" [disable]="true" [model]="event" />
    }
    @if (event.stream && !mediaEnabled) {
        <vn-icon class="video-icon" name="sports-video-badge-b" width="15" height="10" [class.video-icon-live]="event.live" />
    }
    @if (event.league.combiLeague) {
        <vn-icon class="sport-icon" size="11" name="sports-{{ event.sport.id }}" />
    }
    <div class="event-info-container">
        <ms-event-timer
            class="grid-event-timer"
            [ngClass]="{ 'price-boost-wrapper': !!priceBoostCount }"
            [live]="event.live"
            [start]="event.startDate"
            [scoreboard]="event.scoreboard" />
        @if (broadcaster$ | async; as broadcaster) {
            <div class="broadcast-info-ellipsis"><span class="dot">•</span>{{ broadcaster }}</div>
        }
    </div>
    @if (!!this.liveEventInfo) {
        <span class="grid-live-event-info">{{ liveEventInfo }}</span>
    }
}
@if (showFixedFooterSection) {
    <ng-content />
    @if (showBetBuilderIcon) {
        <span class="bet-builder-icon" (click)="builderClick($event)">
            @if (showIcon) {
                <i class="sports-build-a-bet"></i>
            }
            <span class="bet-builder-text">{{ sitecore.eventGrid.BetBuilderBadgeText }}</span>
        </span>
    }
    <ng-template #header>
        <ms-betbuilder-overlay-header
            [eventName]="event.name"
            [sportId]="event.sport.id"
            [leagueId]="event.league.id"
            [eventId]="event.id"
            [eventStartDate]="event.startDate"
            [eventParticipants]="event.participants"
            [eventViewType]="event.viewType" />
    </ng-template>
    @if (priceBoostCount) {
        <ms-priceboost-count-signpost [count]="priceBoostCount" />
    }
}
